import Breadcrumb from "../components/Breadcrumb";
import VehicleModesLayer from "../components/VehicleModesLayer";


const VehicleModesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Vehicle Models" />

      <VehicleModesLayer />
    </>
  );
};

export default VehicleModesPage;
